export default __webpack_public_path__ + "static/moda-427252bc7c597355192b79f08d4251bc.jpg";